var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9992 16C31.9992 24.8367 24.8359 32 15.9992 32C7.16328 31.9992 0 24.8359 0 16C0 7.16328 7.16328 0 16 0C24.8367 0 32 7.16328 32 16H31.9992Z",
    fill: "#333D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1686 20.1228V12.1953C19.1686 12.1953 20.0625 13.6851 23.2934 13.7761C23.4657 13.781 23.6083 13.6392 23.6083 13.4669V11.2265C23.6083 11.0598 23.4754 10.9277 23.3087 10.9181C20.8025 10.7763 19.6123 8.85404 19.4955 7.09121C19.485 6.92773 19.3417 6.80371 19.1782 6.80371H16.623C16.453 6.80371 16.3145 6.94142 16.3145 7.11215V19.7145C16.3145 21.0836 15.2684 22.2746 13.901 22.339C12.3379 22.4131 11.0671 21.0715 11.2604 19.4858C11.3973 18.3656 12.296 17.4484 13.4138 17.2929C13.636 17.2623 13.8527 17.2599 14.0629 17.2833C14.2489 17.3042 14.4124 17.1657 14.4124 16.9789V14.7328C14.4124 14.5734 14.2908 14.4349 14.1313 14.4252C13.8108 14.4043 13.4822 14.4115 13.1488 14.4494C10.6838 14.7288 8.69463 16.7236 8.42162 19.1895C8.06165 22.4421 10.5984 25.1955 13.7786 25.1955C16.7558 25.1955 19.1694 22.782 19.1694 19.8047",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.87477d91344e7885100c2218241a55f6.svg";
export { ForwardRef as ReactComponent };